import { Pipe, PipeTransform } from '@angular/core';
import { LocalisationService } from '../services/localisation.service';
import { Observable } from 'rxjs';

@Pipe({
    name: 'translate'
})
export class TranslatePipe implements PipeTransform {

    constructor(private localisationService: LocalisationService) {
    }

    transform(key: string, ...args: string[]): Observable<string> {
        return this.localisationService.getTranslation(key, ...args);
    }

}
